import { getUserInfo } from "../../../../../reducers/authSlice";
import Skeleton from "react-loading-skeleton";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import HTTPService from "../../../../../utils/axios";
import ProfileImage from "../../../../../components/ProfileImage";
import { CheckCircle, XCircle } from "lucide-react";

const ResearcherLeaderBoard = () => {
  const [researcherPortfolioLoad, setResearcherPortfolioLoad] = useState(false);
  const ASSET_URL = process.env.REACT_APP_ASSET_URL;
  const { invokeApi } = HTTPService();
  const [researcherPortfolio, setResearcherPortfolio] = useState([]);
  const { userInfo } = useSelector(getUserInfo);

  useEffect(() => {
    if (userInfo && userInfo.user_data) {
      getResearcherPortfolio();
    }
  }, [userInfo]);

  const getResearcherPortfolio = async () => {
    setResearcherPortfolioLoad(true);
    invokeApi({
      method: "GET",
      url: `widget/researcher-leader-board/`,
    })
      .then((data) => {
        setResearcherPortfolioLoad(false);
        setResearcherPortfolio(data);
      })
      .catch((error) => {
        customToast.error("Something went wrong!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
        setResearcherPortfolioLoad(false);
      });
  };

  return (
    <>
      <h5 className="p-3 text-center">Researcher Leaderboard</h5>
      <div className="table-responsive researcherProfile">
        <table className="table align-items-center mb-0 researcherProfileTable">
          <thead className="table-primary">
            <tr>
              <th className="text-uppercase text-white font-weight-bolder th-first">
                Researcher
              </th>
              <th className="text-uppercase text-white font-weight-bolder">
                Total <br /> Submissions
              </th>
              <th className="text-uppercase text-white font-weight-bolder">
                Valid <br /> Submissions
              </th>
              <th className="text-uppercase text-white font-weight-bolder">
                Critical <br /> Findings
              </th>
              <th className="text-uppercase text-white font-weight-bolder ps-2">
                Points <br /> Earned
              </th>
              <th className="text-uppercase text-white font-weight-bolder ps-2">
                KYC <br /> Status
              </th>
              <th className="text-uppercase text-white font-weight-bolder ps-2">
                Updated <br /> At
              </th>
              <th className="text-uppercase text-white font-weight-bolder ps-2">
                Progress <br /> Meter
              </th>
            </tr>
          </thead>
          <tbody>
            {researcherPortfolioLoad
              ? Array(5)
                  .fill()
                  .map((item) => (
                    <tr>
                      <td>
                        <div className="d-flex">
                          <div className="me-2">
                            <div className="outsideBorder">
                              <div className="customerProfilePic">
                                <Skeleton height={"100%"} width={"100%"} />
                              </div>
                            </div>
                          </div>
                          <div className="text-start">
                            <span className="text-xxs">
                              <Skeleton height={14} width={"100%"} />
                            </span>
                            <p className="mb-0" style={{ fontSize: "14px" }}>
                              <Skeleton height={14} width={"100%"} />
                            </p>
                          </div>
                        </div>
                      </td>
                      <td>
                        <p className="  mb-0 px-2" style={{ fontSize: "14px" }}>
                          <Skeleton height={14} width={"100%"} />
                        </p>
                      </td>

                      <td className="cell-breakWord">
                        <Skeleton height={14} width={"100%"} />
                      </td>
                      <td>
                        <Skeleton height={14} width={"100%"} />
                      </td>
                      <td>
                        <Skeleton height={14} width={"100%"} />
                      </td>
                      <td>
                        {/* <p className="  mb-1">{item.progress} %</p> */}
                        <div className="">
                          <Skeleton height={9} width={120} />
                        </div>
                      </td>
                    </tr>
                  ))
              : researcherPortfolio &&
                researcherPortfolio.map(
                  (item, index) =>
                    index < 5 && (
                      <tr key={index}>
                        <td>
                          <div className="d-flex">
                            <div className="me-2">
                              <div className="outsideBorder">
                                <div className="customerProfilePic">
                                  <ProfileImage
                                    src={ASSET_URL + item.display_pic}
                                    alt=""
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="text-start">
                              <span
                                // style={{ color: "#8955D6" }}

                                className="text-xxs"
                                style={{
                                  fontSize: "14px",
                                  fontWeight: 600,
                                }}
                              >
                                <b
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: 600,
                                  }}
                                >
                                  {item.username}
                                </b>
                              </span>
                              <p
                                style={{
                                  fontSize: "14px",
                                  fontWeight: 600,
                                }}
                                className="mb-0 fw-bold"
                              >
                                {item.first_name} {item.last_name}
                              </p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <p
                            className="  mb-0 px-2 fw-bold"
                            style={{
                              fontSize: "14px",
                              fontWeight: 600,
                            }}
                          >
                            {item.total_reports}
                          </p>
                        </td>

                        <td className="cell-breakWord">
                          <p
                            className="  mb-0 fw-bold"
                            style={{
                              fontSize: "14px",
                              fontWeight: 600,
                            }}
                          >
                            {item.valid_reports}
                          </p>
                        </td>
                        <td>
                          <p
                            className="  mb-0 fw-bold"
                            style={{
                              fontSize: "14px",
                              fontWeight: 600,
                            }}
                          >
                            {item.critical_findings}
                          </p>
                        </td>
                        {/* <td>
                                    <p className="  mb-0">
                                      {item.highest_rewards}
                                    </p>
                                  </td> */}
                        <td>
                          <p
                            className="  mb-0 fw-bold"
                            style={{
                              fontSize: "14px",
                              fontWeight: 600,
                            }}
                          >
                            {item.reward_points}
                          </p>
                        </td>
                        <td>
                          {item.kyc_status === "active" ? (
                            <CheckCircle
                              size={20}
                              color="green"
                              title="Verified"
                            />
                          ) : (
                            <XCircle
                              size={20}
                              color="red"
                              title="Not Verified"
                            />
                          )}
                        </td>
                        <td>
                          <p
                            className="mb-0 fw-bold"
                            style={{ fontSize: "14px", fontWeight: 600 }}
                          >
                            {new Date(item.kyc_updated_at).toLocaleDateString()}
                          </p>
                        </td>
                        <td>
                          <p
                            className="  mb-1 fw-bold"
                            style={{
                              fontSize: "14px",
                              fontWeight: 600,
                            }}
                          >
                            {item.total_reports === 0 ||
                            item.valid_reports === 0
                              ? "0.0%"
                              : (
                                  (parseInt(item.valid_reports) /
                                    parseInt(item.total_reports)) *
                                  100
                                ).toFixed(1) + "%"}
                          </p>
                          <div className="progress">
                            <div
                              key={index}
                              style={{
                                width:
                                  item.total_reports === "0" ||
                                  item.valid_reports === "0"
                                    ? "0%"
                                    : (
                                        (parseInt(item.valid_reports) /
                                          parseInt(item.total_reports)) *
                                        100
                                      ).toFixed(0) + "%",
                                backgroundColor:
                                  item.total_reports === "0" ||
                                  item.valid_reports === "0"
                                    ? "#f7ccac"
                                    : (parseInt(item.valid_reports) /
                                        parseInt(item.total_reports)) *
                                        100 <=
                                      20
                                    ? "#f7ccac"
                                    : (parseInt(item.valid_reports) /
                                        parseInt(item.total_reports)) *
                                        100 <=
                                      40
                                    ? "#ed7d31"
                                    : (parseInt(item.valid_reports) /
                                        parseInt(item.total_reports)) *
                                        100 <=
                                      60
                                    ? "#98c3e6"
                                    : (parseInt(item.valid_reports) /
                                        parseInt(item.total_reports)) *
                                        100 <=
                                      80
                                    ? "#0072bf"
                                    : "#00af52",

                                fontSize: "14px",
                                fontWeight: 600,
                              }}
                              className="progress-bar fw-bold"
                              role="progressbar"
                              aria-valuenow="0"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </td>
                        {/* <td>
                                    <p className="  mb-0">
                                      {item.reputationPoints}
                                    </p>
                                  </td> */}
                      </tr>
                    )
                )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ResearcherLeaderBoard;
